import { useHistory } from "react-router-dom";

import { NavigationActions } from "./NavigationActions";

export const useNavigationActions = () => {
  const history = useHistory();
  return new NavigationActions(history);
};
